import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { GetQuotePackagePageQueryVariables, QuoteStatus } from '../gql/graphql';
import { useMemo } from 'react';
import { getPaginatedNodes } from './utils';

export const GET_QUOTE_PACKAGE_PAGE = graphql(`
  query getQuotePackagePage($submissionUuid: String) {
    quotes(
      filters: { submissionUuid: $submissionUuid, type: USER_QUOTE }
      sort: { order: "ASC", key: "order" }
    ) {
      pageInfo {
        totalResults
      }
      edges {
        cursor
        node {
          uuid
          name
          order
          status
          referenceId
        }
      }
    }
  }
`);

export function useGetQuotePackagePage({
  submissionUuid,
  ...variables
}: GetQuotePackagePageQueryVariables) {
  const { loading, error, data } = useQuery(GET_QUOTE_PACKAGE_PAGE, {
    variables: {
      submissionUuid,
      ...variables,
    },
  });

  const { quotes } = useMemo(() => {
    return {
      quotes: getPaginatedNodes(data?.quotes).filter(
        (quote) =>
          quote.status &&
          [QuoteStatus.Quoted, QuoteStatus.Bound].includes(quote.status)
      ),
    };
  }, [data?.quotes]);

  return {
    error,
    loading,
    data,
    quotes,
  };
}
